import { render, staticRenderFns } from "./drivers-info.vue?vue&type=template&id=b6146990&scoped=true&"
import script from "./drivers-info.vue?vue&type=script&lang=js&"
export * from "./drivers-info.vue?vue&type=script&lang=js&"
import style0 from "./drivers-info.vue?vue&type=style&index=0&id=b6146990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6146990",
  null
  
)

export default component.exports